import { Component } from '@angular/core';
import { FileUploadZoneComponent } from '../../shared/components/file-upload-zone/file-upload-zone.component';

@Component({
  selector: 'app-compare-filings',
  imports: [FileUploadZoneComponent],
  templateUrl: './compare-filings.component.html',
})
export class CompareFilingsComponent {
  protected onFiles(_files: File[]): void {
    // Compare engine — planned in a later phase.
  }
}
